import { Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react"; // lightweight icon set

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const linkClass = ({ isActive }) =>
    `uppercase tracking-wide font-semibold transition block py-2 md:py-0 ${
      isActive ? "text-white" : "text-gray-400 hover:text-white"
    }`;

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 dosis uppercase ${
        scrolled
          ? "bg-black/90 backdrop-blur border-b border-gray-700"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="text-2xl font-heading text-white">
          <img
            className="w-[180px]"
            src="/ti-logo.png"
            alt="Throttled Ink Logo"
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex gap-8">
          <li>
            <NavLink to="/" className={linkClass}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/gallery" className={linkClass}>
              Gallery
            </NavLink>
          </li>
          <li>
            <a href="mailto:info@throttledink.com" className="text-white">
              Book
            </a>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-white focus:outline-none"
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur border-t border-gray-800">
          <ul className="flex flex-col items-center py-6 space-y-4">
            <li>
              <NavLink
                to="/"
                onClick={() => setMenuOpen(false)}
                className={linkClass}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/gallery"
                onClick={() => setMenuOpen(false)}
                className={linkClass}
              >
                Gallery
              </NavLink>
            </li>
            <li>
              <a href="mailto:info@throttledink.com" className="text-white">
                Book
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
